import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, hasAnalyticsConsent } from '@/lib/analytics';

/**
 * Hook to track route changes for analytics — no-ops without consent.
 */
export const useRouteTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (hasAnalyticsConsent()) {
      trackPageView(location.pathname + location.search);
    }
  }, [location.pathname, location.search]);
};